import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
// import ProtectedRoute from '../../routes/Route-protected/ProtectedRoute';
import PublicRoute from '../../routes/Route-protected/PublicRoute';
import ProtectedRoute from '../../routes/Route-protected/ProtectedRoute';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => {
				// eslint-disable-next-line react/jsx-props-no-spreading
				let { element } = page;
				if (page.protected) {
					element = <ProtectedRoute>{element}</ProtectedRoute>;
				} else if (page.publicOnly) {
					element = <PublicRoute>{element}</PublicRoute>;
				}
				return <Route key={page.path} path={page.path} element={element} />;
			})}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
